import { useMemo, Fragment } from "react"
import PropTypes from "prop-types"
import { isEmpty, omit, identity } from "lodash"
import { useQueryStringState } from "hooks/query-string"
import DataIntegrator from "gatherers/data-integrator"
import CompareSection from "../renderers/compare-section"

export default function DataIntegratedSection({ configKey, section, positionSets, index, defaultFormatter = identity }) {
  const [rawQueryState, updateQueryString] = useQueryStringState(configKey)
  const queryState = useMemo(() => !isEmpty(rawQueryState) ? rawQueryState : undefined, [rawQueryState])

  return (
    <Fragment>
      <DataIntegrator
        metrics={section.metrics}
        dataTransform={section.dataTransform}
        Renderer={section.renderer || CompareSection}
        rendererProps={{
          queryState,
          onQueryStateChange: updateQueryString,
          index,
          formatter: defaultFormatter,
          configKey,
          columnCount: positionSets.length,
          positionSetsMetadata: positionSets,
          ...omit(section, ["id", "metrics", "renderer", "dataTransform"]),
        }}
      />
      {section.separator && <div style={{ marginTop: 18 }} />}
    </Fragment>
  )
}

DataIntegratedSection.propTypes = {
  configKey: PropTypes.string.isRequired,
  section: PropTypes.shape({
    id: PropTypes.string.isRequired,
    metrics: PropTypes.array.isRequired,
    renderer: PropTypes.elementType,
    separator: PropTypes.bool,
    dataTransform: PropTypes.func,
  }).isRequired,
  positionSets: PropTypes.arrayOf(
    PropTypes.shape({
      length: PropTypes.number.isRequired,
    }),
  ).isRequired,
  index: PropTypes.number.isRequired,
  defaultFormatter: PropTypes.func,
}
